import { render, staticRenderFns } from "./AddContract.vue?vue&type=template&id=a22c3022&"
import script from "./AddContract.vue?vue&type=script&lang=js&"
export * from "./AddContract.vue?vue&type=script&lang=js&"
import style0 from "./AddContract.vue?vue&type=style&index=0&id=a22c3022&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports